import React from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import { List } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import loginSteam from '@shared/assets/images/cyber/loginSteam.jpg';
export const SteamTooltip = () => <WrapperTooltip>
    <Heading>Как найти свой логин в Steam?</Heading>
    <Spacer space={20} spacetablet={20} spacemob={20} />
    <WrapperList>
      <List data={[{
      id: 1,
      text: 'Откройте клиент Steam. Нажмите на имя пользователя в правом верхнем углу главной страницы.'
    }, {
      id: 2,
      text: 'В выпадающем меню выберите пункт «Об аккаунте».'
    }]} size="md" sizemob="md" />
    </WrapperList>
    <Spacer space={20} spacetablet={20} spacemob={20} />
    <ImageWrapper>
      <Image src={loginSteam} width={536} height={140} alt="login steam" style={{
      borderRadius: '16px'
    }} />
    </ImageWrapper>
  </WrapperTooltip>;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const WrapperTooltip = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperTooltip",
  class: "w1vpwl4m",
  propsAsIs: false,
  vars: {
    "w1vpwl4m-0": [_exp()],
    "w1vpwl4m-1": [_exp2()],
    "w1vpwl4m-2": [_exp3()],
    "w1vpwl4m-3": [_exp4()],
    "w1vpwl4m-4": [_exp5(), "px"]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const WrapperList = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperList",
  class: "w15pbbxw",
  propsAsIs: false,
  vars: {
    "w15pbbxw-0": [_exp6()]
  }
}));
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.md;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.sm;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "hw6guep",
  propsAsIs: false,
  vars: {
    "hw6guep-0": [_exp7()],
    "hw6guep-1": [_exp8(), "px"],
    "hw6guep-2": [_exp9()],
    "hw6guep-3": [_exp0(), "px"],
    "hw6guep-4": [_exp1()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i105ieiu",
  propsAsIs: false
});

require("./SteamTooltip.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamTooltip.tsx");